
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/user';
import Footer from './components/Footer.vue';
import FooterInfo from './components/FooterInfo.vue';
import tFooterInfo from './components/tFooterInfo.vue';

@Component({
  name: 'mainLayout',
  components: {
    Footer,
    FooterInfo,
    tFooterInfo,
  },
})

export default class extends Vue {
  created() {
    if (!UserModule.token) {
      this.$router.push({ name: 'Login' });
    }
  }

  private heightFix = false;

  private menuList: any = [];

  private fixHeight() {
    this.heightFix = !this.heightFix;
  }
}
